<template>
    <div class="account-actions">

     <a v-if="rowData.status == 1" target="_blank"><button @click="showLanguageModal" class="btn btn-primary"><i class="fas fa-eye"></i></button></a>
     <button class="btn btn-danger" v-confirm="{ok: dialog => deleteProfiel(dialog, rowData.profielid),  okText: 'Verwijderen', cancelText : 'Annuleren',  cancel: doNothing, message: 'Weet u zeker dat u deze gebruikt wilt verwijderen?'}"><i class="fas fa-times"></i></button>
      
     <!-- Language Selection Modal -->
     <div v-if="isLanguageModalVisible" class="modal">
         <div class="modal-content">
             <span class="close" @click="closeLanguageModal">&times;</span>
             <h2>Select Language</h2>
             <select v-model="selectedLanguage" class="form-control language-input">
                <option value="nl">Nederlands</option>
                <option value="en">English</option>
                <option value="fr">Français</option>
             </select>
             <button @click="viewInSelectedLanguage" class="btn btn-primary">View</button>
         </div>
     </div>
      
    </div>
  </template>

  <script>
  export default {
    props: {
      rowData: {
        type: Object,
        required: true
      },
      rowIndex: {
        type: Number
      }
    },
    data() {
        return {
            isLanguageModalVisible: false,
            selectedLanguage: 'nl'
        };
    },
    methods: {
      deleteProfiel: function(dialog, rowID) {
      $.ajax({
        type: 'DELETE',
        url: '/profiel/' + rowID,
        dataType: 'json',
        headers: { 'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content') },
        data: {id:rowID},

        success: function (data) {
          location.reload();        
        },
        error: function (data) {
          alert(" fout" );
        }
      });
      },
      doNothing: function() {
        // Do nothing or some other stuffs
      },
      showLanguageModal() {
        this.isLanguageModalVisible = true;
      },
      closeLanguageModal() {
        this.isLanguageModalVisible = false;
      },
      viewInSelectedLanguage() {
        window.open(`profiel/${this.rowData.profielid}?lang=${this.selectedLanguage}`, '_blank');
        this.closeLanguageModal();
      }
    }
  }
  </script>

  <style>
.dg-btn--ok {
    color: #fff;
    background-color: #c82333;
    border-color: #bd2130;
 }
 
 .dg-btn--cancel {
  background: #818181;
  border-color:#818181;
  color:#fff;
 }

 .modal {
    display: block;
    position: fixed;
    z-index: 1;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgb(0,0,0);
    background-color: rgba(0,0,0,0.4);
}
.modal-content {
    background-color: #fefefe;
    margin: 15% auto;
    padding: 20px;
    border: 1px solid #888;
    width: 20rem;
}
.close {
  display: block;
  position: relative;
    color: #aaa;
    float: right;
    font-size: 28px;
    font-weight: bold;
    width: 20px;
}
.close:hover,
.close:focus {
    color: black;
    text-decoration: none;
    cursor: pointer;
}

.language-input{
    margin-bottom: 1rem;
}
  </style>
